module.exports = __webpack_public_path__ + "img/stopwatch.32a20cb5.svg";